import type { PanelProps } from "../panel-props"

import { useDatabaseLength } from "../../../modules/database-length-store"
import { IS_AUTH } from "../../../modules/auth"
import { useSettings } from "../../../modules/settings"
import { Badge } from "../../badge"
import { Select } from "../../select"
import { Slider } from "../../slider"
import { ToggleButton } from "../../toggle-button"
import { SharedSettings } from "../shared-settings.tsx"
import { useToggleRevealItSetting } from "../toggle-app-setting-hooks.ts"

const SPEED = {
  max: 3000,
  min: 800,
  step: 100,
}

const SOURCE_OPTIONS = [
  { key: "bookmarks", label: "bookmarks" },
  { key: "core bookmarks", label: "core bookmarks" },
  { key: "pair of word", label: "pair of word" },
]

const REVEAL_IT_INDEX_KEYS = {
  bookmarks: "revealIt_bookmarks",
  "core bookmarks": "revealIt_coreBookmarks",
  "pair of word": "revealIt_pairOfWord",
}

export function RevealItSettings({ closeSidebar }: PanelProps) {
  const { appSettings, setAppSettings } = useSettings()
  const databaseLength = useDatabaseLength()
  const indexKey =
    REVEAL_IT_INDEX_KEYS[appSettings.revealIt.source] ?? "revealIt_bookmarks"
  const currentIndex = appSettings.index[indexKey] ?? 0
  const [revealEndOfWordIsOn, toggleRevealEndOfWord] =
    useToggleRevealItSetting("revealEndOfWord")

  const onSpeedValueChange = (newSpeed: number)=> {
    setAppSettings("speed", newSpeed, "revealIt")
  }

  const onChangeSource = (value: string)=> {
    setAppSettings("source", value, "revealIt")
  }

  return (
    <SharedSettings closeSidebar={closeSidebar}>
      {IS_AUTH && (
        <section className="sidebar__section">
          <h3 className="sidebar__section-title">Source</h3>
          <Select
            initialValue={appSettings.revealIt.source}
            label="Source"
            onChange={onChangeSource}
            options={SOURCE_OPTIONS}
          />
        </section>
      )}

      <div className="sidebar__separator" role="separator" />

      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Display</h3>
        <ToggleButton
          checked={revealEndOfWordIsOn}
          label="Reveal end of word"
          onChange={toggleRevealEndOfWord}
        />
      </section>

      <div className="sidebar__separator" role="separator" />

      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Playback</h3>
        <Slider
          label="Reveal speed (ms)"
          max={SPEED.max}
          min={SPEED.min}
          onValueChange={onSpeedValueChange}
          step={SPEED.step}
          value={appSettings.revealIt.speed}
        />
      </section>

      <div className="sidebar__separator" role="separator" />

      <section className="sidebar__section">
        <h3 className="sidebar__section-title">Position</h3>
        <div>
          index <Badge value={String(currentIndex)} /> from{" "}
          <Badge value={String(databaseLength - 1)} />
        </div>
      </section>
    </SharedSettings>
  )
}
